export default __webpack_public_path__ + "32d8fa547b257eb02246273266bf5d01.png";